/**
  Статусы увольнения агента
 */

export const FIRED_STATUSES = {
  await: 'wait_new_agency', // Ожидание ввода агентства
  agreement: 'coordination', // Согласование
  approved: 'approved', // Утверждено
};
